/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const IconAdd = ({ className, color }) => {
  return (
    <svg
      className={`icon-add ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M15 10L5 10"
        stroke={color ? color : "#38342F"}
        strokeWidth="2"
      />
      <path
        className="path"
        d="M10 5L10 15"
        stroke={color ? color : "#38342F"}
        strokeWidth="2"
      />
    </svg>
  );
};
